import {NgModule} from '@angular/core';
import {CheckboxInputComponent} from "./checkbox-input.component";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {MatCheckboxModule} from "@angular/material/checkbox";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        MatCheckboxModule
    ],
    declarations: [
        CheckboxInputComponent,
    ],
    exports: [
        CheckboxInputComponent
    ]
})
export class CheckboxInputModule {}
